import { OnACallMessage, FullCapacityMessage, OverCapacityMessage } from './AgentCapacityMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const AgentCapacityStatusMessage = ({
  messageType
}) => {
  switch (messageType) {
    case 'ON_A_CALL':
      return /*#__PURE__*/_jsx(OnACallMessage, {});
    case 'FULL_TOTAL':
      return /*#__PURE__*/_jsx(FullCapacityMessage, {
        messageType: "FULL_TOTAL"
      });
    case 'FULL_MESSAGING':
      return /*#__PURE__*/_jsx(FullCapacityMessage, {
        messageType: "FULL_MESSAGING"
      });
    case 'FULL_ASYNC':
      return /*#__PURE__*/_jsx(FullCapacityMessage, {
        messageType: "FULL_ASYNC"
      });
    case 'OVER_TOTAL':
      return /*#__PURE__*/_jsx(OverCapacityMessage, {
        messageType: "OVER_TOTAL"
      });
    case 'OVER_MESSAGING':
      return /*#__PURE__*/_jsx(OverCapacityMessage, {
        messageType: "OVER_MESSAGING"
      });
    case 'OVER_ASYNC':
      return /*#__PURE__*/_jsx(OverCapacityMessage, {
        messageType: "OVER_ASYNC"
      });
    default:
      return null;
  }
};
AgentCapacityStatusMessage.displayName = 'AgentCapacityStatusMessage';